import React from 'react';
import { Space } from 'antd';
import { RiseOutlined, FallOutlined } from '@ant-design/icons';

function PositionChange(props) {
    if (props.player) {
        if (props.player.lpiPreviousRanking - props.player.lpiRanking < 0) {
            return (<Space style={{color: '#D80032'}}><FallOutlined />-{props.player.lpiRanking - props.player.lpiPreviousRanking}</Space>)
        } 
        if (props.player.lpiPreviousRanking - props.player.lpiRanking > 0) {
            return (<Space style={{color: '#0f5132'}}><RiseOutlined/>+{props.player.lpiPreviousRanking - props.player.lpiRanking}</Space>)
        } 
    } else {
        return <div></div>
    }
}

export default PositionChange;